
import stringMixin from './stringMixin';

export default {
  name: 'XhSelect', // 新建 select
  components: {},
  mixins: [stringMixin],
  props: {
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      option: []
    };
  },

  computed: {},
  watch: {
    item: {
      handler: function handler(val) {
        if (val && (val.setting || val.data.setting)) {
          var data = val.setting ? val : val.data;
          var settingList = data.setting;
          if (settingList.length > 0 && typeof settingList[0] == 'string') {
            var array = [];
            for (var index = 0; index < settingList.length; index++) {
              var element = settingList[index];
              array.push({ name: element, value: element });
            }
            this.option = array;
          } else if (settingList.length > 0 && settingList[0].statusId && !settingList[0].value) {
            // 商机阶段
            this.option = settingList.map(function (item, index, array) {
              item.value = item.statusId;
              return item;
            });
          } else {
            this.option = settingList;
          }
        } else {
          this.option = [];
        }
      },

      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {}
};